import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-item" }
const _hoisted_2 = { class: "app-item__heading" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "field" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "app-item__actions" }

import { ListAppItem } from './models/ListApp';
import { PropType } from 'vue';
import { useVModel } from '@vueuse/core';
import useVuelidate, { Validation } from '@vuelidate/core';
import { helpers, required, url } from '@vuelidate/validators';
import VuelidateUtil from '@shared/util/vuelidateUtil';


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentHighlightsListItemEdit',
  props: {
  modelValue: {
    type: Object as PropType<ListAppItem>,
    required: true,
  },
  itemIndex: {
    type: Number,
    default: 0,
  },
  totalItems: {
    type: Number,
    default: 0,
  },
},
  emits: ["update:modelValue", "remove"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const value = useVModel(props, 'modelValue', emit);

const validations = {
  url: { required, url },
  label: { required },
  description: { required },
  image: { url },
};

const $v = useVuelidate(validations, value);

function markAsTouched(key: keyof ListAppItem) {
  const field = $v.value[key];
  if (field) {
    field.$touch();
  }
  emit('update:modelValue', value.value);
}

function getErrorMessage(fieldName: keyof ListAppItem, label: string): string | null {
  return VuelidateUtil.getErrorMessage($v, fieldName, label);
}

function removeItem() {
  emit('remove');
}

return (_ctx: any,_cache: any) => {
  const _component_n_text_input = _resolveComponent("n-text-input")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, "Highlight " + _toDisplayString(__props.itemIndex + 1), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_n_text_input, {
        modelValue: _unref(value).url,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(value).url) = $event)),
        label: "Link URL",
        errorMessage: getErrorMessage('url', 'Link URL'),
        onInput: _cache[1] || (_cache[1] = () => markAsTouched('url'))
      }, null, 8, ["modelValue", "errorMessage"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_n_text_input, {
        modelValue: _unref(value).label,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(value).label) = $event)),
        label: "Link Label",
        errorMessage: getErrorMessage('label', 'Link Label'),
        onInput: _cache[3] || (_cache[3] = () => markAsTouched('label'))
      }, null, 8, ["modelValue", "errorMessage"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_n_text_input, {
        modelValue: _unref(value).description,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(value).description) = $event)),
        label: "Link Description",
        errorMessage: getErrorMessage('description', 'Link Description'),
        onInput: _cache[5] || (_cache[5] = () => markAsTouched('description'))
      }, null, 8, ["modelValue", "errorMessage"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_n_text_input, {
        modelValue: _unref(value).image,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(value).image) = $event)),
        label: "Link Image",
        errorMessage: getErrorMessage('image', 'Link Image'),
        onInput: _cache[7] || (_cache[7] = () => markAsTouched('image'))
      }, null, 8, ["modelValue", "errorMessage"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_n_button_group, null, {
        default: _withCtx(() => [
          _createVNode(_component_n_button, {
            variant: "primary--outline",
            onClick: removeItem,
            disabled: __props.totalItems === 1
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
              _createTextVNode("Remove Item", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _: 1
      })
    ]),
    _cache[9] || (_cache[9] = _createElementVNode("hr", null, null, -1))
  ]))
}
}

})